module.exports = __webpack_public_path__ + "img/04-1-1实时处理.22ef9b5b.svg";